import { useEffect } from 'react';
import { UseFormSetError, UseFormClearErrors, FieldValues } from 'react-hook-form';

interface IUseCustomFormErrorParams<T extends FieldValues> {
  errorKey: string;
  shouldShowError: boolean;
  errorMessage: string;
  setError: UseFormSetError<T>;
  clearErrors: UseFormClearErrors<T>;
}

export const useCustomFormError = <T extends FieldValues>({
  errorKey,
  shouldShowError,
  errorMessage,
  setError,
  clearErrors,
}: IUseCustomFormErrorParams<T>) => {
  useEffect(() => {
    if (shouldShowError) {
      setError(errorKey as any, {
        type: 'manual',
        message: errorMessage,
      });
    } else {
      clearErrors(errorKey as any);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldShowError]);
};
